import { render } from "./TableRolesPermissions.vue?vue&type=template&id=c149922a&scoped=true"
import script from "./TableRolesPermissions.vue?vue&type=script&lang=js"
export * from "./TableRolesPermissions.vue?vue&type=script&lang=js"

import "./TableRolesPermissions.vue?vue&type=style&index=0&id=c149922a&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c149922a"]])

export default __exports__